import styles from './overview.module.scss';

interface IProps {
  overall: {
    win: number;
    loss: number;
    winPercentage: number | string;
  };
  conference?: {
    win: number;
    loss: number;
    winPercentage?: number | string;
  };
  matchType?: string;
  heading: string;
  subheading?: string;
}

const Overview = ({ overall, conference, matchType, heading, subheading }: IProps) => {
  return (
    <div className={styles.overview}>
      {heading && (
        <h2>
          {heading}
          {matchType && ':'}
          <span>{matchType}</span>
        </h2>
      )}
      {subheading && <h3>{subheading}</h3>}
      <ul className={styles.overviewList}>
        <li className={styles.overviewListItem}>
          <p>
            <span className={styles.overviewListItemTitle}>
              {!matchType && 'Overall'} win - loss {matchType}
            </span>
            <span className={styles.overviewListItemResult}>
              {overall.win} - {overall.loss}
            </span>
          </p>
        </li>
        <li className={styles.overviewListItem}>
          <p>
            <span className={styles.overviewListItemTitle}>Overall win %</span>
            <span className={styles.overviewListItemResult}>
              {overall.winPercentage === 0 ? '-' : `${overall.winPercentage}%`}
            </span>
          </p>
        </li>

        {conference && (
          <>
            <li className={styles.overviewListItem}>
              <p>
                <span className={styles.overviewListItemTitle}>
                  <abbr title="Conference">Conf</abbr> win - loss
                </span>
                <span className={styles.overviewListItemResult}>
                  {conference?.win} - {conference?.loss}
                </span>
              </p>
            </li>
            <li className={styles.overviewListItem}>
              <p>
                <span className={styles.overviewListItemTitle}>
                  <abbr title="Conference">Conf</abbr> win %
                </span>
                <span className={styles.overviewListItemResult}>
                  {conference.winPercentage === 0 ? '-' : `${conference.winPercentage}%`}
                </span>
              </p>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default Overview;
